import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    // Każde przejście (także „wstecz") zaczyna stronę od góry.
    scrollRestoration: false,
    defaultPreloadStaleTime: 0,
    trailingSlash: "never",
  });

  return router;
};
